import { ActionType } from '../interfaces/ActionType';
import {
    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL
} from '../helpers/constants';

export interface IAddress {
    country?: string;
    province?: string;
    district?: string;
    area?: string;
    landmark?: string;
}

export interface IAuthUser {
    id?: string;
    name?: string;
    email?: string;
    slug?: string;
    phone?: string;
    address?: IAddress;
    profile?: string;
    gender?: string;
    dob?: Date;
    email_verified?: boolean;
    phone_verified?: boolean;
}

export interface AuthState {
    redirectToReferrer: boolean;
    authenticated: boolean;
    authUser: IAuthUser;
    registerLoading: boolean;
    redirectLogin: boolean;
    loginLoading: boolean;
    loginError?: string;
    registerError?: string;
}

const initialState: AuthState = {
    redirectToReferrer: false,
    authenticated: false,
    authUser: {},
    registerLoading: false,
    redirectLogin: false,
    loginLoading: false
};

const authReducer = (state = initialState, action: ActionType) => {
    const { type, payload } = action;
    switch (type) {
        case REGISTER_REQUEST:
            return {
                ...state,
                registerLoading: true
            };
        case REGISTER_SUCCESS:
            return {
                ...state,
                redirectLogin: true,
                registerError: null,
                registerLoading: false
            };

        case REGISTER_FAIL:
            return {
                ...state,
                registerError: action.payload,
                registerLoading: false
            };

        case LOGIN_REQUEST:
            return {
                ...state,
                loginLoading: true
            };

        case LOGIN_SUCCESS:
            return {
                ...state,
                redirectToReferrer: true,
                authenticated: true,
                authUser: payload,
                loginError: null,
                loginLoading: false
            };

        case LOGIN_FAIL:
            return {
                ...state,
                loginError: action.payload,
                loginLoading: false
            };

        default:
            return state;
    }
};

export default authReducer;
